import { cva } from "class-variance-authority";

export const card = cva("bg-white transition-all duration-300", {
  variants: {
    bordered: {
      true: "border border-solid border-primary",
    },
    rounded: {
      true: "rounded-lg",
    },
    hoverable: {
      true: "overflow-hidden hover:border-primary-100 lg:hover:shadow-lg hover:cursor-pointer",
      expand: "relative hover:z-10 hover:border-primary-100 lg:hover:shadow-lg",
      false: "overflow-hidden",
    },
    fullwidth: {
      true: "w-full",
      false: "max-w-3xl",
    },
  },
  defaultVariants: {
    bordered: true,
    hoverable: false,
    rounded: true,
    fullwidth: false,
  },
});
